import { useEffect } from 'react';
import {
  ALTERNATE_ORG_NAMES,
  CONTACT_EMAIL,
  DEFAULT_DESCRIPTION,
  DEFAULT_TITLE,
  KNOWS_ABOUT,
  OG_IMAGE_URL,
  SITE_NAME,
  SITE_URL,
} from '../config/seo';

function buildGraph() {
  const orgId = `${SITE_URL}/#organization`;
  const websiteId = `${SITE_URL}/#website`;

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': orgId,
        name: SITE_NAME,
        alternateName: ALTERNATE_ORG_NAMES,
        url: SITE_URL,
        logo: { '@type': 'ImageObject', url: OG_IMAGE_URL },
        description: DEFAULT_DESCRIPTION,
        email: CONTACT_EMAIL,
        areaServed: [
          { '@type': 'Country', name: 'Nigeria' },
          { '@type': 'Place', name: 'Africa' },
        ],
        knowsAbout: KNOWS_ABOUT,
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer support',
          email: CONTACT_EMAIL,
          areaServed: ['NG', 'Africa', 'Worldwide'],
          availableLanguage: ['English'],
        },
      },
      {
        '@type': 'WebSite',
        '@id': websiteId,
        url: SITE_URL,
        name: SITE_NAME,
        description: DEFAULT_DESCRIPTION,
        inLanguage: 'en',
        publisher: { '@id': orgId },
      },
      {
        '@type': 'WebPage',
        '@id': `${SITE_URL}/#webpage`,
        url: SITE_URL,
        name: DEFAULT_TITLE,
        description: DEFAULT_DESCRIPTION,
        isPartOf: { '@id': websiteId },
        about: { '@id': orgId },
        primaryImageOfPage: { '@type': 'ImageObject', url: OG_IMAGE_URL },
      },
      {
        '@type': 'ProfessionalService',
        '@id': `${SITE_URL}/#service`,
        name: `${SITE_NAME} — enterprise & custom software`,
        url: SITE_URL,
        description: DEFAULT_DESCRIPTION,
        provider: { '@id': orgId },
        areaServed: [
          { '@type': 'Country', name: 'Nigeria' },
          { '@type': 'AdministrativeArea', name: 'Africa' },
        ],
        serviceType: KNOWS_ABOUT,
      },
    ],
  };
}

const SCRIPT_ID = 'ca-seo-jsonld';

export default function SeoJsonLd() {
  useEffect(() => {
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) existing.remove();

    const el = document.createElement('script');
    el.id = SCRIPT_ID;
    el.type = 'application/ld+json';
    el.textContent = JSON.stringify(buildGraph());
    document.head.appendChild(el);

    return () => {
      el.remove();
    };
  }, []);

  return null;
}
